import { CoefficientOption } from '@/domain/models/coefficientOption';
import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
import FournitureReference from '@/models/FournitureReference';
import { AxiosPromise } from 'axios';
const rootPath = 'coefficientoptions';


class CoefficientOptionService {
  
    public  GetCoefficientOptionsTableUrl(coefficientId:string,lang:string,isAdmin = true): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}${buildQuery({lang ,coefficientId,isAdmin})}`;
    }
    
    public GetCoefficientOptionsByCoefficient(coefficientId:string,lang:string,isAdmin:boolean = false){
        return apiClient.get(`${rootPath}${buildQuery({lang ,coefficientId,isAdmin})}`);
    }

    public GetCoefficientsOptionsByCoefficient(coefficientsId: Array<string>, lang: string, isAdmin: boolean = false){
        // Switch to POST to avoid long query strings when many IDs
        return apiClient.post(
            `${rootPath}/byCoefficients${buildQuery({ lang, isAdmin })}`,
            coefficientsId
        );
    }
 
    
    public GetCoefficientOptionsByKey(coefficientKey:string,bopModelId:string,lang:string){
        return apiClient.get(`${rootPath}/byKey${buildQuery({lang ,coefficientKey,bopModelId})}`);
    }
    public GetPossibleCoefficientOptions(coefficientId:string,operationId:string,lang:string){
        return apiClient.get(`${rootPath}/getPossibleCoefficientOptions${buildQuery({lang ,operationId,coefficientId})}`);
    }
 
    public async SaveCoefficientOptions(coefficientConfig:Array<Object>,lang:string): Promise<any> {
        return apiClient.post(`${rootPath}${buildQuery({lang})}`,coefficientConfig);
    }

    public  GetVisibleOperationFamiliesUrl(coefficientId:string,lang:string): string {
        return `${apiClient.defaults.baseURL || ''}${rootPath}/GetVisibleOperationFamilies${buildQuery({coefficientId,lang})}`;
    }
    public async SetVisibleOperationFamilies(fournitureReferenceDtos:Array<FournitureReference>): Promise<any> {
        return apiClient.post(`${rootPath}/SetVisibleOperationFamilies`,fournitureReferenceDtos);
    }

    public deleteCoefficientOption(coefficientOptionId:string):AxiosPromise{
        return apiClient.delete(`${rootPath}/${coefficientOptionId}`)
    }

    public deleteNatureDesTachesCoefficient(coefficientOptionId:string,operationFamiliesIds:string[]):AxiosPromise{
        return apiClient.post(`${rootPath}/delete-nature-des-taches/${coefficientOptionId}`,operationFamiliesIds)
    }

    public GetCoefficientOptionsByCoefficientSiteType(coefficientId: string, siteId: string, typeTravauxId: string, lang:string): Promise<any>{
        if (coefficientId && siteId && typeTravauxId) {
            return apiClient.get(`${rootPath}/byCoefficientSiteType${buildQuery({ coefficientId, siteId, typeTravauxId, lang })}`);
        }
        return Promise.resolve(undefined);
    }

        public getUsedSiteTypeTravauxByBopModelId(coefficientId: string): AxiosPromise {
            return apiClient.get(`${rootPath}/usedSiteTypeTravaux${buildQuery({coefficientId})}`);
        }

}

export default new CoefficientOptionService();

export type CoefficientOptionSaveRequest = {
    coefficientsOptionsToDelete: Array<string>,
    coefficientsOptionsToSave: Array<CoefficientOption>
    languageCode:string
}